import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { Subject, forkJoin } from 'rxjs';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var DetailService = /** @class */ (function () {
    function DetailService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.defaultId = '00000000-0000-0000-0000-000000000000';
        this.detail = new Subject();
        this.getDetailChanged$ = this.detail.asObservable();
        this.currentPropertyFocus = new Subject();
        this.currentPropertyFocusChanged$ = this.currentPropertyFocus.asObservable();
        this.currentLookup = new Subject();
        this.currentLookupChanged$ = this.currentLookup.asObservable();
        this.parentChild = new Subject();
        this.parentChildChanged$ = this.parentChild.asObservable();
        this.disableChild = new Subject();
        this.disableChild$ = this.disableChild.asObservable();
        this.treeData = new Subject();
        this.treeDataChanged = this.treeData.asObservable();
        this.loadMore = new Subject();
        this.loadMoreChanged = this.loadMore.asObservable();
        this.pendingUpdateProps = [];
        this.loginUrl = this.env.servicePath;
    }
    DetailService.prototype.setLookup = function (name) {
        this.currentLookup.next(name);
    };
    DetailService.prototype.setPropertyFocus = function (name) {
        this.currentPropertyFocus.next(name);
    };
    DetailService.prototype.clearChild = function (prop) {
        this.parentChild.next(prop);
    };
    DetailService.prototype.setDisableChild = function (prop) {
        this.disableChild.next(prop);
    };
    DetailService.prototype.setTreeData = function (data) {
        this.treeData.next(data);
    };
    DetailService.prototype.setLoadMore = function (data) {
        this.loadMore.next(data);
    };
    DetailService.prototype.isNewDetail = function (detail) {
        this.detail.next(detail);
    };
    DetailService.prototype.pushPendingUpdate = function (property, value) {
        if (property) {
            var index = this.pendingUpdateProps.findIndex(function (x) { return x.id == property.PropertyId; });
            if (index > -1)
                this.pendingUpdateProps.splice(index, 1);
            this.pendingUpdateProps.push({ id: property.PropertyId, property: property, value: value });
        }
    };
    DetailService.prototype.removePendingUpdate = function (propertyId) {
        if (this.pendingUpdateProps.find(function (x) { return x.id == propertyId; })) {
            this.pendingUpdateProps.splice(this.pendingUpdateProps.findIndex(function (x) { return x.id == propertyId; }));
        }
    };
    DetailService.prototype.clearPendingUpdate = function () {
        this.pendingUpdateProps = [];
    };
    DetailService.prototype.getPendingUpdate = function () {
        return this.pendingUpdateProps;
    };
    DetailService.prototype.getDetail = function (id) {
        var path = this.loginUrl + "GetDetailCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.getAnonymousDetail = function (id) {
        var path = this.loginUrl + "GetDetailCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.newDetail = function (type, id) {
        var path = this.loginUrl + "GetNewDetail/" + type + "/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    DetailService.prototype.updateField = function (id, fieldName, fieldValue, selectionValue) {
        if (selectionValue === void 0) { selectionValue = ""; }
        var path = this.loginUrl + "DetailUpdatePropertyValue/" + id + "/" + fieldName + "?selectionValue=" + selectionValue;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, fieldValue, httpOptions);
    };
    DetailService.prototype.updateMultiFields = function (id, fieldObj) {
        var getObs = [];
        for (var _i = 0, fieldObj_1 = fieldObj; _i < fieldObj_1.length; _i++) {
            var field = fieldObj_1[_i];
            var path = this.loginUrl + "DetailUpdatePropertyValue/" + id + "/" + field.name + "?selectionValue=" + field.selectionValue;
            var httpOptions = {
                headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
            };
            getObs.push(this.http.post("" + path, field.value, httpOptions));
        }
        return forkJoin(getObs);
    };
    DetailService.prototype.anonymousUpdateField = function (id, fieldName, fieldValue) {
        var path = this.loginUrl + "DetailUpdatePropertyValue/" + id + "/" + fieldName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
        };
        return this.http.post("" + path, fieldValue, httpOptions);
    };
    DetailService.prototype.detailAction = function (id, actionCommand) {
        var path = this.loginUrl + "DetailAction/" + id + "/" + actionCommand;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    DetailService.prototype.anonymousDetailAction = function (id, actionCommand) {
        var path = this.loginUrl + "DetailAction/" + id + "/" + actionCommand;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    DetailService.prototype.changeSection = function (id, sectionId) {
        var path = this.loginUrl + "ChangeSection/" + id + "/" + sectionId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    DetailService.prototype.createInfoCard = function (id, name) {
        var path = this.loginUrl + "CreateInfoCard/" + id + "/" + name;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    DetailService.prototype.getInfoCard = function (id) {
        var path = this.loginUrl + "GetInfoCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.getLookupList = function (id, propertyName, groupValue) {
        if (groupValue === void 0) { groupValue = ""; }
        var path = this.loginUrl + "GetDropdownList/" + id + "/" + propertyName + "?groupValue=" + groupValue;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.searchDropdownList = function (id, propertyName, keyword) {
        var path = this.loginUrl + "SearchDropdownList/" + id + "/" + propertyName + "?keyword=" + keyword;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.searchInDropdownList = function (id, propertyName, keyword) {
        var path = this.loginUrl + "SearchInDropdownList/" + id + "/" + propertyName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, keyword, httpOptions);
    };
    DetailService.prototype.getHelp = function (id) {
        var path = this.loginUrl + "GetHelp/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.getFixedMessageText = function (id, propertyId) {
        var path = this.loginUrl + "GetFixedPropertyValue/" + id + "/" + propertyId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.getCurrentSection = function (id) {
        var path = this.loginUrl + "GetCurrentSection/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.requestSupplierRegistration = function (data) {
        var path = this.loginUrl + "RequestSupplierRegistration";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true' })
        };
        return this.http.post("" + path, data, httpOptions);
    };
    DetailService.prototype.getPreview = function (id, actionCommand) {
        var path = this.loginUrl + "CreateDetailPreview/" + id + "/" + actionCommand;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    DetailService.prototype.getPreviewNextSection = function (id, sectionSize) {
        var path = this.loginUrl + "CreatePreviewNextSection/" + id + "?sectionSize=" + sectionSize;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    DetailService.prototype.getSectionStatus = function (id, sectionId) {
        var path = this.loginUrl + "GetSectionStatus/" + id + "/" + sectionId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.getCurrentWorkspaceItems = function (id) {
        var path = this.loginUrl + "GetCurrentWorkspaceItems/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.getDateTimePropertyDateSegmentValue = function (id, propertyName) {
        var path = this.loginUrl + "GetDateTimePropertyDateSegmentValue/" + id + "/" + propertyName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.getDateTimePropertyTimeSegmentValue = function (id, propertyName) {
        var path = this.loginUrl + "GetDateTimePropertyTimeSegmentValue/" + id + "/" + propertyName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.getNewDetailFromPropertyGroup = function (detailCardId, propertyGroupId) {
        var path = this.loginUrl + "GetNewDetailFromPropertyGroup/" + detailCardId + "/" + propertyGroupId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    DetailService.prototype.checkActionPrompt = function (id, actionCommand) {
        var path = this.loginUrl + "CheckActionPrompt/" + id + "/" + actionCommand;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    DetailService.prototype.newFormFromDetail = function (detailCardId, propertyGroupId) {
        var path = this.loginUrl + "NewFormFromDetail/" + detailCardId + "/" + propertyGroupId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    DetailService.prototype.getFormDetailCard = function (id) {
        var path = this.loginUrl + "GetFormDetailCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.updateFormPropertyValue = function (id, propertyName, value) {
        var path = this.loginUrl + "UpdateFormPropertyValue/" + id + "/" + propertyName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, value, httpOptions);
    };
    DetailService.prototype.updateFormPropertyRemarks = function (id, propertyName, value) {
        var path = this.loginUrl + "UpdateFormPropertyRemarks/" + id + "/" + propertyName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, value, httpOptions);
    };
    DetailService.prototype.updateFormBaseRemarks = function (id, propertyName, value) {
        var path = this.loginUrl + "UpdateFormPropertyBaseRemarks/" + id + "/" + propertyName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, value, httpOptions);
    };
    DetailService.prototype.actionFormDetailCard = function (id, actionCommand) {
        var path = this.loginUrl + "ActionFormDetailCard/" + id + "/" + actionCommand;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    DetailService.prototype.checkIfDetailHasUpdate = function (id) {
        var path = this.loginUrl + "CheckIfDetailHasUpdate/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    DetailService.prototype.clearSummarySelectedItem = function (id) {
        var path = this.loginUrl + "ClearSummarySelectedItem/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    DetailService.ngInjectableDef = i0.defineInjectable({ factory: function DetailService_Factory() { return new DetailService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: DetailService, providedIn: "root" });
    return DetailService;
}());
export { DetailService };
